var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "changelog" } }, [
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "logo" }),
      _vm._v(" "),
      _c("div", { staticClass: "version" }, [
        _vm._v("Version " + _vm._s(_vm.version))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "dialog-content" }, [
      _c("div", { staticClass: "changelog" }, [
        _c("div", { staticClass: "section-title" }, [_vm._v("UPDATE 2.1.0")]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _c("div", { staticClass: "name" }, [_vm._v("Knowledge Base")]),
            _vm._v(" "),
            _c("div", { staticClass: "value" }, [
              _vm._v(
                "Need help using Vilio? Take a look at our new Knowledge Base: "
              ),
              _c(
                "a",
                { attrs: { target: "_blank", href: _vm.urls.knowledgeBase } },
                [_vm._v(_vm._s(_vm.urls.knowledgeBase))]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "section-title" }, [
            _vm._v("Management Features")
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _vm._m(2)
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "divider" }),
        _vm._v(" "),
        _c("div", { staticClass: "section-title" }, [_vm._v("UPDATE 2.0.1")]),
        _vm._v(" "),
        _vm._m(3),
        _vm._v(" "),
        _c("div", { staticClass: "text" }, [
          _vm._v(
            "For a full list of features, changes, and updates, view our "
          ),
          _c(
            "span",
            { staticClass: "link", on: { click: _vm.openChangelog } },
            [_vm._v("full Changelog")]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "version-prompt" },
        [
          _c("v-checkbox", {
            staticClass: "checkbox",
            attrs: {
              "hide-details": "",
              color: "primary",
              label: "Show this when I use a new version for the first time."
            },
            model: {
              value: _vm.changelogPrompt,
              callback: function($$v) {
                _vm.changelogPrompt = $$v
              },
              expression: "changelogPrompt"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "dialog-footer" },
      [
        _c(
          "v-btn",
          {
            staticClass: "button",
            attrs: { loading: _vm.lockout.on, flat: "", color: "info" },
            on: { click: _vm.closeDialog }
          },
          [_vm._v("Done")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("div", { staticClass: "name" }, [_vm._v("Unit Roles")]),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [
        _vm._v(
          "Invites can now be created directly on a unit. Existing users can also now be added directly to a unit."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("div", { staticClass: "name" }, [_vm._v("Searching")]),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [
        _vm._v("People, Invites, and Units are now searchable.")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("div", { staticClass: "name" }, [_vm._v("Bug Fixes")]),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [_vm._v("Minor bug fixes.")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", [
        _c("div", { staticClass: "name" }, [_vm._v("Mobile Applications")]),
        _vm._v(" "),
        _c("div", { staticClass: "value" }, [
          _vm._v(
            "Vilio 2.0.1 is now available on the Android and iOS app stores."
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "name" }, [_vm._v("Browser Support")]),
        _vm._v(" "),
        _c("div", { staticClass: "value" }, [
          _vm._v("Added support for Internet Explorer 11.")
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "name" }, [_vm._v("Bug Fixes")]),
        _vm._v(" "),
        _c("div", { staticClass: "value" }, [_vm._v("Minor bug fixes.")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b05bf94", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b05bf94","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Changelog.vue
// module id = 458
// module chunks = 4